import React from 'react';

interface CompanyFilterProps {
  companies: Array<{ id: number; name: string }>;
  selectedCompanyId: number | null;
  onCompanySelect: (companyId: number | null) => void;
  className?: string;
}

const CompanyFilter: React.FC<CompanyFilterProps> = ({
  companies,
  selectedCompanyId,
  onCompanySelect,
  className = ''
}) => {
  return (
    <select
      className="form-select form-select-sm"
      value={selectedCompanyId === null ? '' : selectedCompanyId.toString()}
      onChange={e =>
        onCompanySelect(e.target.value ? parseInt(e.target.value) : null)
      }
      style={{ minWidth: '150px', maxWidth: '150px' }}
    >
      <option value="">All Companies</option>
      {companies.map(company => (
        <option key={company.id} value={company.id}>
          {company.name}
        </option>
      ))}
    </select>
  );
};

export default CompanyFilter;
